import imgQrCode1 from '@assets/images/common/footer/qrCode1.jpg'
import imgQrCode2 from '@assets/images/common/footer/qrCode2.jpg'
import imgQrCode3 from '@assets/images/common/footer/qrCode3.jpg'
import imgQrCode4 from '@assets/images/common/footer/qrCode4.jpg'
import imgQrCode5 from '@assets/images/common/footer/qrCode5.jpg'

import type { FC } from 'react'
import Description from '../Description'
import './index.scss'

const copyright = '沪ICP备2021015255号-1 Copyright © 2021-2026 中免日上互联科技有限公司'
const certificateInfo = [
  {
    text: '增值电信业务经营许可证：沪B2-20211215',
    href: 'https://beian.miit.gov.cn/',
  },
  { text: '药品、医疗器械互联网信息服务备案凭证：沪网药信备字〔2025〕 00073号' },
  { text: '医疗器械网络交易服务第三方平台备案凭证：（沪）网械平台备字〔2026〕第00001号' },
  {
    text: '沪公网安备31011502401732号',
    href: 'https://beian.mps.gov.cn/#/query/webSearch?code=31011502401732',
  },
  {
    text: '营业执照：41000000202507230094',
    href: 'https://lefox-app-cdn.cdfsunrise.com/resources/front/images/2026-04-10/9881bb6d-2fd4-4306-8ed1-9e8164bfec0a__1775803090301__w1125__h795.jpeg',
  },
]
const mediaInfo = [
  { img: imgQrCode1, desc: '微信公众号' },
  { img: imgQrCode2, desc: '微信视频号' },
  { img: imgQrCode3, desc: '微博' },
  { img: imgQrCode4, desc: '小红书' },
  { img: imgQrCode5, desc: '抖音' },
]

const Footer: FC = () => {
  return (
    <div className="footer-page">
      <div className="page-container">
        <section className="info-wrapper flexRow">
          <Description
            title={'客服热线'}
            titleStyle={{ fontSize: '20px' }}
            style={{ width: '280px' }}
            desc={
              <>
                <p>在线客服：App/小程序</p>
                <p>工作时间：9:00-23:00</p>
                <p>电话客服：4001-100-100</p>
                <p>工作时间：10:00-22:00</p>
              </>
            }
          />
          <Description
            title={'品牌入驻'}
            titleStyle={{ fontSize: '20px' }}
            desc={
              <>
                <p>procurement@cdfsunrise.com</p>
                <Description
                  title={'证照信息'}
                  titleStyle={{ fontSize: '20px', marginTop: '40px' }}
                  desc={
                    <>
                      <p>
                        <a href="https://lefox-app-cdn.cdfsunrise.com/html/statement/certificate.html" target="_blank" rel="noopener noreferrer">
                          点击查看
                        </a>
                      </p>
                    </>
                  }
                  style={{ width: '280px' }}
                />
              </>
            }
            style={{ width: '280px' }}
          />
          <Description
            title={'社交媒体'}
            titleStyle={{ fontSize: '20px' }}
            style={{ width: '578px' }}
            desc={
              <div className="media-box">
                {mediaInfo.map((item) => {
                  return (
                    <div className="media-item" key={item.desc}>
                      <img src={item.img} alt={item.desc + '二维码'} />
                      <p className="media-item-desc">{item.desc}</p>
                    </div>
                  )
                })}
              </div>
            }
          />
        </section>
        <div className="copyright">
          <p className="certificate-line">{copyright}</p>
          <div className="certificate-list">
            {certificateInfo.map((item) => {
              return (
                <p className="certificate-line" key={item.text}>
                  {item.href ? (
                    <a href={item.href} target="_blank" rel="noopener noreferrer">
                      {item.text}
                    </a>
                  ) : (
                    item.text
                  )}
                </p>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
